import React from 'react';
import { HERO_IMAGE, HERO_NOTICE, PIZZERIA_NAME } from '../constants';

const isHeroNoticeVisible = () =>
  !HERO_NOTICE?.hiddenFrom || new Date() < new Date(HERO_NOTICE.hiddenFrom);

const Hero = ({ onPrimaryAction, onSecondaryAction }) => {
  const showNotice = isHeroNoticeVisible();

  return (
    <section className="hero-section">
      <div className="hero-background">
        <img
          src={HERO_IMAGE.url}
          alt={HERO_IMAGE.alt}
          className="h-full w-full object-cover"
        />
        <div className="hero-background-overlay" />
      </div>
      <div className="hero-glow hero-glow-left" />
      <div className="hero-glow hero-glow-right" />

      {showNotice && (
        <div className="absolute inset-x-0 bottom-0 top-20 z-30 flex items-center justify-center bg-stone-950/75 p-4 backdrop-blur-sm">
          <div className="max-h-full w-full max-w-4xl overflow-y-auto rounded-3xl bg-white/95 p-6 text-center shadow-2xl md:p-8">
            <p className="text-xl font-bold text-stone-900 md:text-2xl">{HERO_NOTICE.title}</p>
            <p className="mt-3 text-sm text-stone-700 md:text-base">{HERO_NOTICE.greeting}</p>
            {HERO_NOTICE.paragraphs.map((paragraph, index) => (
              <p key={index} className="mt-2 text-sm leading-6 text-stone-700 md:text-base">
                {paragraph}
              </p>
            ))}
            <p className="mt-3 text-sm font-semibold text-stone-900 md:text-base">
              {HERO_NOTICE.signature}
            </p>
          </div>
        </div>
      )}

      <div className="mx-auto flex min-h-[calc(100vh-5rem)] max-w-7xl items-center px-6 py-16 lg:px-10 lg:py-20">
        <div className="hero-content-panel flex max-w-3xl flex-col justify-center">
          <h1 className="hero-handwritten mt-6 max-w-3xl text-5xl font-semibold text-white md:text-7xl">
            {PIZZERIA_NAME}
          </h1>
          <p className="hero-copy mt-6 max-w-2xl text-lg leading-8 text-stone-100 md:text-xl">
            Authentische italienische Steinofenpizza, frisch zubereitet mit
            hochwertigen Zutaten, präzisem Handwerk und einem Service, auf den
            man sich jederzeit verlassen kann.
          </p>

          <div className="mt-8 flex flex-col gap-3 sm:flex-row">
            <button
              type="button"
              onClick={onPrimaryAction}
              className="inline-flex items-center justify-center rounded-full bg-white px-6 py-3 text-sm font-semibold text-stone-950 transition duration-300 hover:-translate-y-0.5 hover:bg-orange-100"
            >
              Karte ansehen
            </button>
            <button
              type="button"
              onClick={onSecondaryAction}
              className="inline-flex items-center justify-center rounded-full border border-white/60 bg-white/10 px-6 py-3 text-sm font-semibold text-white backdrop-blur-sm transition duration-300 hover:-translate-y-0.5 hover:bg-white/20"
            >
              Kontakt
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
